import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function OffcanvasCreateEmailTemplate({ show, onHide, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Create new email template')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Name')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Email Template Key */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="key">{t('Unique name')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="key"
                                            placeholder={t('Enter unique name for email template')}
                                            required
                                            onBlur={(e) => {
                                                const formattedValue = e.target.value.toLowerCase().replace(/\s+/g, '_');
                                                e.target.value = formattedValue;
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Value')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Email Template Value Subject */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="subject">{t('Subject')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            id="subject"
                                            placeholder={t('Enter subject')}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Email Template Value Body */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="body">{t('HTML body')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            id="body"
                                            placeholder={t('Enter HTML body')}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Create email template')}
                                </>
                            ) : (
                                t('Create email template')
                            )}
                        </Button>
                    </div>

                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasCreateEmailTemplate;